import {
  ITimeOffPolicy,
  ITimeOffTemplate,
  ITimeOffType,
  ITimeOffTypeData,
  TimeOffPolicy,
  TimeOffTemplate,
  TimeOffType
} from '@/models';
import { ITimeOffState } from '@/store/timeoff';

import { ITimeOffGetters } from './getters.types';

export const getters: ITimeOffGetters = {
  getTimeOffCount(state: ITimeOffState): number {
    return state.count;
  },

  getTimeOffTypes(state: ITimeOffState): ITimeOffType[] {
    return state.timeOffTypes.map(data => new TimeOffType(data));
  },

  getTimeOffPolicyById: (state: ITimeOffState) => (
    id: number
  ): ITimeOffPolicy | undefined => {
    const data = state.timeOffPolicies.find(
      timeOffPolicy => timeOffPolicy.id === id
    );
    if (!data) {
      return undefined;
    }

    return new TimeOffPolicy(data);
  },

  getTimeOffTemplates(state: ITimeOffState): ITimeOffTemplate[] {
    return state.templates.map(data => new TimeOffTemplate(data));
  },

  getTimeOffTemplateById: (state: ITimeOffState) => (
    id: number
  ): ITimeOffTemplate | undefined => {
    const data = state.templates.find(template => template.id === id);
    if (!data) {
      return undefined;
    }

    return new TimeOffTemplate(data);
  },

  getTimeOffPolicies(state: ITimeOffState): ITimeOffPolicy[] {
    return state.timeOffPolicies.map(data => new TimeOffPolicy(data));
  },

  getTimeOffPolicyByTimeOffTypeId: (state: ITimeOffState) => (
    id: number
  ): ITimeOffPolicy | undefined => {
    const data = state.timeOffPolicies.find(
      policy => (policy.timeoff as ITimeOffTypeData).id === id
    );
    if (!data) {
      return undefined;
    }

    return new TimeOffPolicy(data);
  }
};
